import { render, staticRenderFns } from "./OpacityChoice.vue?vue&type=template&id=02bbfb23&scoped=true&"
import script from "./OpacityChoice.vue?vue&type=script&lang=js&"
export * from "./OpacityChoice.vue?vue&type=script&lang=js&"
import style0 from "./OpacityChoice.vue?vue&type=style&index=0&id=02bbfb23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bbfb23",
  null
  
)

export default component.exports